import { FC } from 'react';

import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import ComparisonHeaderLogo from 'components/Tables/Comparison/components/ComparisonHeaderLogo';
import MobileComparisonTable from 'components/Tables/Comparison/components/MobileComparisonTable';
import TableRow from 'components/Tables/Comparison/components/TableRow';
import { ComparisonTableConfigProps } from 'components/Tables/Comparison/config';

import { hasArrayValues } from 'utils/array/arrays';

const ComparisonTable: FC<ComparisonTableConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { competitor, rows } = rest;
  const renderCompares = ['prismatic', 'competitor'];

  return (
    <Section {...sectionProps}>
      <ScrollFadeSection delay={0.2}>
        <table className="hidden w-full table-fixed border-separate border-spacing-0 overflow-hidden md:table">
          <thead>
            <tr>
              <td colSpan={2} />
              <th scope="col" className="relative rounded-t-lg bg-primary-300 p-5">
                <div className="flex w-full justify-center">
                  <ComparisonHeaderLogo isPrismatic />
                </div>
              </th>
              <th scope="col">
                <div className="flex w-full justify-center">
                  {competitor?.competitorName && <ComparisonHeaderLogo competitor={competitor} />}
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white/5">
            {hasArrayValues(rows) &&
              rows.map((row, idx) => {
                const isLastRow = idx === rows?.length - 1;

                return <TableRow key={row.id} isLastRow={isLastRow} {...row} />;
              })}
          </tbody>
        </table>
        <div className="flex w-full flex-col gap-4 md:hidden">
          {renderCompares?.map(item => (
            <MobileComparisonTable key={item} isPrismatic={item === 'prismatic'} {...rest} />
          ))}
        </div>
      </ScrollFadeSection>
    </Section>
  );
};

export default ComparisonTable;
